<template>
  <div>
    <base-tooltip :color="value ? 'primary' : 'grey'" bottom :disabled="$vuetify.breakpoint.xs">
      <template #activator="{ on }">
        <div v-on="on">
          <v-badge overlap :content="count" :value="count">
            <v-btn
              :class="value ? 'active' : ''"
              :fab="!icon"
              :icon="icon"
              x-small
              @click="$emit('input', !value)"
              :color="value ? 'primary' : 'grey'"
              :dark="!value"
              ><v-icon size="20">
                {{ iconComputed }}
              </v-icon></v-btn
            >
          </v-badge>
        </div>
      </template>
      <span>Drive</span>
    </base-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    icon: {
      type: Boolean,
      default: false
    },
    count: {
      type: Number,
      default: 0
    }
  },
  computed: {
    iconComputed() {
      return 'mdi-cloud';
    }
  }
};
</script>

<style scoped lang="scss">
// .active {
//   transform: rotate(45deg);
// }
</style>
